import { motion, useTransform, useScroll } from 'motion/react';

const Hero = () => {
  const { scrollYProgress } = useScroll();
  // scrollYProgress is a value between 0 and 1

  // Map scroll progress to scale (1 → 0.5)
  const scaleBg = useTransform(scrollYProgress, [0, 0.1], [1, 0.8]);
  const scaleText = useTransform(scrollYProgress, [0, 0.1], [0.5, 1.75]);
  const opacityText = useTransform(scrollYProgress, [0, 0.1], [0, 1]);
  const y = useTransform(scrollYProgress, [0, 0.2], [200, 0]);

  return (
    <section className="landing-hero relative overflow-hidden flex items-center justify-center py-20 h-screen
                        m:h-auto m:min-h-dvh m:py-12
                        ml:min-h-0 ml:py-8">
      <span className="absolute left-0 right-0 top-0 bottom-0 landing-hero-gr z-20" />
      <motion.div
        className="absolute left-0 right-0 top-0 bottom-0 landing-hero-img z-10"
        style={{ scale: scaleBg }}
        initial={{ scale: 1 }}
      />
      <div className="relative z-30 text-common-white">
        <motion.div className="w-full max-w-3xl px-4 text-center">
          <h1 className="font-primary text-title md:text-heroTitle m:text-title2-m">
            The digital SAT is a <strong className="text-primary font-extraBold">GAME</strong>.
            <br /> It’s not an IQ test.
          </h1>
          <h2 className="block font-primary text-heroSubtitle mx-auto mt-9 w-full max-w-xl px-1
                         m:text-body m:mt-5">
            It’s not a test of intelligence...
            it’s a game of skill that can be taught - it’s a game of skill that can be learned by YOU!
          </h2>
        </motion.div>
        <motion.div
          initial={{ scale: 1, opacity: 0 }}
          className="text-center mt-20 h-40 m:mt-10 m:h-24"
          style={{ scale: scaleText, y, opacity: opacityText }}
        >
          <span className="font-primary text-title md:text-heroTitle !font-bold m:text-title2-m">GAME ON</span>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
